import React from 'react';
import { Typography, Stack } from '@mui/material';
import SectionPaper from '../../../common/components/styled-ui-elements/SectionPaper';
import { WriteoffAmountField, WriteoffReasonField, JustificationNotesField } from '../fieldEditors';

export const WriteoffDetailsSection: React.FC = () => {
  return (
    <SectionPaper>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
        Writeoff Details
      </Typography>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <WriteoffAmountField />
          <WriteoffReasonField />
        </Stack>
        <JustificationNotesField />
      </Stack>
    </SectionPaper>
  );
};

export default WriteoffDetailsSection;
